import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Experience, Home, Projects, Education } from './routes';
import Navbar from "./components/Navbar/Navbar"
import Footer from "./components/Footer/Footer"
import LifeQuotes from './components/LifeQuotes/LifeQuotes';


function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/education" element={<Education />} />
      </Routes>
      <LifeQuotes />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
